import { Point } from './point';
import { GraphicElement } from './graphicelement';

export class Polygon implements GraphicElement {

    public allPoint: Array<Point> = [];
}
